<script>
export default {
  name: 'IconFpPet',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7" cy="8" r="1.8" :stroke="color" stroke-width="1.6" />
    <circle cx="12" cy="6" r="1.8" :stroke="color" stroke-width="1.6" />
    <circle cx="17" cy="8" r="1.8" :stroke="color" stroke-width="1.6" />
    <circle cx="19" cy="13" r="1.6" :stroke="color" stroke-width="1.6" />
    <path d="M12 11a4 4 0 0 1 3.7 2.5l.7 1.7A2.4 2.4 0 0 1 14.2 18.5c-.8 0-1.5-.4-2.2-.4s-1.4.4-2.2.4a2.4 2.4 0 0 1-2.2-3.3l.7-1.7A4 4 0 0 1 12 11z" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
